import rect from "react"
import RightSidebarGlobal from "../../Components/RightSidebarGlobal"

function Engineering(){

    return (
        <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Engineering</h1>

    <p>The West Bengal State Cooperative Marketing Federation Ltd, popularly known as BENFED, is a 
      state-level apex cooperative marketing society which was established and registered in 1958, 
      under W.B.C.S. Acts, 1940, by the Department of Cooperation, Government of West Bengal.</p>

	<p>BENFED plays a pivotal role in supporting the agricultural sector through a variety of engineering works aimed at augmentation of 
    productivity, efficiency, and sustainability. By engaging in a range of projects, BENFED contributes to the overall development of the 
    agricultural landscape in the state of West Bengal. BENFED has worked as a Project Implementing Agency (PIA) under various schemes such 
    as, <a href="https://www.ncdc.in" target="_blank">National Cooperative Development Cooperation (NCDC)</a>, 
    <a href="https://finance.wb.gov.in" target="_blank">State Plan (Finance Department)</a>, 
    <a href="https://www.nabard.org" target="_blank">Rural Infrastructure Development Fund (RIDF XV, XVII, XXI, XXII, XXIV)</a>, Warehouse Infrastructure Fund 
    (WIF 22, 23, 24), <a href="https://rkvy.da.gov.in/" target="_blank">Raskhtriya Krishi Vikash Yojna (RKVY)</a> - Remunerative Approaches for Agriculture and 
    Allied sector Rejuvenation (RRVY-RAAFTAR 2023-24, 2024-25) for execution of rural infrastructure projects aimed at establishing 
    potential for income and employment generation in rural areas.</p>
<p>BENFED is also entrusted with the execution of projects of critical stature under State Plan such as, </p>

 <ul class="list_cus">
  <li>G+5 Institute Building at CCM Jhargram (Completion Status-)</li>
  <li>G+6 Commercial Building at B.B.Ganguly Street, Kolkata (Completion Status-)</li>
  <li>A Multipurpose Cold Storage of capacity 1000MT -a Flagship Project of our Honorable Chief Minister at  Bhangar, South 24 Pgns. (Completion Status-)</li>
</ul>
<p>BENFED has the technical expertise for repair and renovation work of Rice Mill including execution of different ancillary 
  works as installation of Weigh Bridge and construction of Flexible and Rigid pavement for smooth execution of work.</p>

<h2>BENFED Undertakes Following EPC (Engineering, Procurement, and Construction) Activities:-</h2>
	
	
<ul className="list_cus">
  <li>(I) <strong ><em ><u>Cold Storage Facilities</u></em></strong>: To address post-harvest challenges, BENFED has worked as Project Implementing Agency (PIA) to the Government of West Bengal for the construction and maintenance work (RIDF XVI) of cold preserve their produce, reducing post-harvest losses and ensuring a steady supply of agricultural products throughout the year. </li>
  <li>(II) <strong ><em ><u>Warehouse Construction</u></em></strong>: Efficient storage is crucial for maintaining the quality of agricultural commodities. BENFED undertakes engineering projects ses equipped for different capacities (100MT to 10000MT) and preservation technologies along with other renovation works. This ensures that farmers have access to proper storage facilities, preventing spoilage and ensuring market readiness. </li>
  <li>(III) <strong ><em ><u>Installation of Oil Mill (Mustard):</u></em></strong> Establishment of a refinery plant encourages the cultivation of oilseed crops which includes mechanization and diversification of agricultural activities. Currently we've been entrusted for the installation of Oil Mill under RKVY. </li>
  <li>(IV) <strong ><em ><u>Seed Processing Unit:</u></em></strong> Establishment of Seed Processing Unit involves keeping and human/animal consumption by keeping physical purity intact with an increased shelf life. BENFED has established such SPU's at different parts of West Bengal for different approved Cooperative Societies registered under Seed Certification Agencies of Govt. WB. </li>
</ul>
<p>BENFED is also responsible for execution of e-procurement through tender, vetted drawing, estimation for different engineering projects under Cooperative sector on request from concerned cooperative societies and order from Directorate of Cooperation, Gov. WB against admissible fees. </p>
	<p>Glimpse of Project wise details undertaken by BENFED as PIA (Project Implementing Agency) in coherence with Cooperation Directorate, Government of West Bengal</p>

<div className="table_data">
  <table border="0" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      <th>Sl No</th>
      <th>Financial Year</th>
      <th>Name of the Scheme</th>
      <th>Category of Project</th>
      <th>No of Projects Undertaken/Initiated</th>
      <th>No of Projects Completed</th>
      <th>Total Cost Involvement (Rs)</th>
      <th>Remarks</th>
    </tr>
  </thead>
  <tbody>
    
    <tr>
      <td>1</td>
      <td>2023-24</td>
      <td>RKVY</td>
      <td>
        1) CONSTRUCTION OF STORAGE GODOWN (100 MT)<br/>
        2) CONSTRUCTION OF WORKSHED-CUM-SALES COUNTER FOR SHGs<br/>
        3) CONSTRUCTION OF SEED PROCESSING UNIT<br/>
        4) CONSTRUCTION OF OIL MILL (MUSTARD)
      </td>
      <td>46</td>
      <td>46</td>
      <td>12.66 Crore</td>
      <td></td>
    </tr>
    <tr>
      <td>2</td>
      <td>2024-25</td>
      <td>RKVY</td>
      <td></td>
      <td>61</td>
      <td>40</td>
      <td>16.04 Crore</td>
      <td></td>
    </tr>
  </tbody>
</table>
</div>


    </div>
    <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div>

    </div>
    </div>

    </>
    )
}

export default Engineering